export const CONSTANT = {
  LOGIN_REDIRECT_PATH: "/",
  DASHBOARD_REDIRECT_PATH: "/candidate-list",
  WITHOUT_LOGIN_PAGE: ["/", "/login"],
  ROUTE: {
    REGISTER: "/register",
    DASHBOARD: "/dashboard",
    FORGOT_PASSWORD: "/forgot-password",
    PROFILE: "/profile",
    CANDIDATE_LIST: "/candidate-list",
    VERIFICATION: "/verification",
    CANDIDATE_DETAIL: "/candidate-detail",
    USER: "user-list",
    ROLE: "role-list",
    MESSAGE: "message-list",
    DOCUMENT: "document-list",
    FORM: "form-list",
    FRAMEWORK: "framework-list",
    EXPIRY_DETAIL: "/expiry-detail",
    UNAUTHORIZED: "/unauthorised",
  },
  REGEX: {
    WEAK_PASSWORD: "/^(?=.*[a-zA-Z]).{6,}$/",
    STRONG_PASSWORD:
      /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?!.* )(?=.*[^a-zA-Z0-9]).{6,}$/,
    NUMERIC: /^[0-9\b]+$/,
    MOBILE: /^[0-9]+$/,
    NO_SPACE: /^[^\s](.*[^\s])?$/,
    NOT_ALLOW_SPECIAL_CHAR_DOT: /^[a-zA-Z0-9\s]*$/,
    ONLY_STRING: /^[A-Za-z]+(?: [A-Za-z]+)*$/,
    STRING_WITH_SPECIAL_SYMBOL: /^[A-Za-z]+([.\-' ][A-Za-z]+)*$/,
  },
  DATE_FORMATS: {
    DMY: "DD MM YYYY",
    DMYHM: "DD MM YYYY HH:mm",
    DMYHMS: "DD MM YYYY HH:mm:ss",
    DMYHMA: "DD MM YYYY hh:mm A",
    DMYHMa: "DD MM YYYY hh:mm a",
    YMD: "YYYY MM DD",
    YMDHM: "YYYY MM DD HH:mm",
    YMDHMS: "YYYY MM DD HH:mm:ss",
    DMY_dash: "DD-MM-YYYY",
    MDY_dash: "MM-DD-YYYY",
    YMDHM_dash: "YYYY-MM-DD HH:mm",
    YMDHMS_dash: "YYYY-MM-DD HH:mm:ss",
    YMD_dash: "YYYY-MM-DD",
    DMY_slash: "DD/MM/YYYY",
    DMYHMS_slash: "DD/MM/YYYY HH:mm:ss",
  },
  GENDER: {
    1: "Male",
    2: "Female",
  },
  CANDIDATE_STATUS_MAPPING: {
    1: "New",
    2: "Assigned",
    3: "Invited",
    4: "InProgress",
    5: "Verified",
    6: "Closed",
    7: "Blocked",
    8: "Reactivated",
  },
  CANDIDATE_STATUS: {
    NEW: 1,
    ASSIGNED: 2,
    INVITED: 3,
    INPROGRESS: 4,
    VERIFIED: 5,
    CLOSED: 6,
    BLOCKED: 7,
    REACTIVATED: 8,
  },
  FORM_STATUS: {
    PENDING: 1,
    SUBMITTED: 2,
    APPROVED: 3,
    REJECTED: 4,
    RESEND: 5,
    NOT_APPLICABLE: 6,
  },
  FORM_STATUS_MAPPING: {
    1: "Pending",
    2: "Submitted",
    3: "Approved",
    4: "Rejected",
    5: "Resent",
    6: "N/A",
  },
  USER_TYPE: {
    CANDIDATE_PORTAL: 1,
    BACK_OFFICE: 2,
  },
  MESSAGES: {
    NOT_SELECT_ASSIGNEE:
      "You cannot send a registration link without selecting an compliance consultant. Please select an compliance consultant to proceed.",
  },
  CANDIDATE_STATUS_COLOR: {
    New: "",
    Assigned: "yellowBg",
    Invited: "",
    InProgress: "yellowBg",
    Verified: "greenBg",
    Closed: "redBg",
    Blocked: "redBg",
    Reactivated: "greenBg",
  },
  FORM_DOC_STATUS_COLOR: {
    Pending: "yellowBg",
    Submitted: "blueBg",
    Approved: "greenBg",
    Rejected: "redBg",
    Resent: "yellowBg",
    "N/A": "",
  },
  MODULE_CODE: {
    DASHBOARD: "Dashboard",
    CANDIDATE: "Candidate",
    USER: "User",
    ROLE: "Role",
    CANDIDATE_APPLICATION: "FormAndDoc",
    MESSAGE: "Message",
    HISTORY: "History",
    DOCUMENT: "Document",
    FORM: "Form",
    FRAMEWORK: "Framework",
  },
  FRAMEWORK_TYPE: {
    STANDARD: 1,
    CUSTOM: 2,
  },
  FRAMEWORK_TYPE_MAPPING: {
    1: "Standard",
    2: "Custom",
  },
  MODULE_PERMISSION: {
    VIEW: "View",
    CREATE: "Create",
    EDIT: "Edit",
    DELETE: "Delete",
    APPROVE: "Approve",
    REJECT: "Reject",
    DOWNLOAD: "Download",
    ASSIGN: "Assign",
  },
  OTP_VALUE: {
    FORGOT_PASSWORD: 1,
    REGISTRATION: 0,
  },
  CUSTOMIZE_MESSAGE: {
    CHARACTER_LENGTH: 2000,
  },
  APPLICATION_TAB: {
    BASIC_INFO: "basic_info",
    FORM: "form",
    DOCUMENT: "document",
    MESSAGE: "message",
    ALL_FORM: "all_form",
  },
  SIG_FORM: {
    FM3A: "FM3A",
    SOE: "SOE",
  },
};
